module.exports = __webpack_public_path__ + "img/banner-6.44308815.jpg";